import { render, staticRenderFns } from "./layer-add-shops.vue?vue&type=template&id=b883d176&scoped=true&"
import script from "./layer-add-shops.vue?vue&type=script&lang=js&"
export * from "./layer-add-shops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b883d176",
  null
  
)

export default component.exports